import { compose, path } from "ramda";

export const scopeSelector = state => state.modules.feedback;

export const getAllInsidersFeedbackApi = compose(
  path(["api", "getAllInsidersFeedback"]),
  scopeSelector
);

export const getInsiderFeedbackApi = compose(
  path(["api", "getInsiderFeedback"]),
  scopeSelector
);

export const getCandidateFeedbackApi = compose(
  path(["api", "getCandidateFeedback"]),
  scopeSelector
);

export const submitInsiderFeedbackApi = compose(
  path(["api", "submitInsiderFeedback"]),
  scopeSelector
);

export const submitCandidateFeedbackApi = compose(
  path(["api", "submitCandidateFeedback"]),
  scopeSelector
);

export const addReviewApi = compose(
  path(["api", "addReviewApi"]),
  scopeSelector
);

export const getCandidateFeedbackResultApi = compose(
  path(["api", "getCandidateFeedbackResult"]),
  scopeSelector
);



// WEBPACK FOOTER //
// ./src/modules/feedback/selectors.js